import { component } from 'flightjs';
import { debounce } from 'packages/debounce';
import breakpoints from 'tradera/legacy/static/utils/breakpoints';

function WindowResize() {
    this._lastWidth = 0;

    this._updateLayout = function () {
        throw 'Lazy defined function, call set first';
    };

    this._setUpdateLayout = function () {
        this._updateLayout = debounce(
            function (evt) {
                const currentWidth = $(window).width();
                if (this._lastWidth === currentWidth) {
                    return;
                }
                this._lastWidth = currentWidth;

                const payload = {
                    small: breakpoints.isVisible(breakpoints.small),
                    medium: breakpoints.isVisible(breakpoints.medium),
                    large: breakpoints.isVisible(breakpoints.large),
                    xlarge: breakpoints.isVisible(breakpoints.xlarge),
                    siteheader: breakpoints.isVisible(breakpoints.siteheader),
                    siteheaderportrait: breakpoints.isVisible(
                        breakpoints.siteheaderportrait
                    ),
                    userResize: !!evt
                };
                this.trigger(document, 'utils:window-resize:resized', payload);
            }.bind(this),
            500
        );
    };

    this.after('initialize', function () {
        this._setUpdateLayout();

        if (window.addEventListener) {
            // Avoid IE8
            window.addEventListener('resize', this._updateLayout, false);
        }
        this._updateLayout(); // on page load
    });

    this.around('teardown', function () {
        if (window.addEventListener) {
            // Avoid IE8
            window.removeEventListener('resize', this._updateLayout);
        }
    });
}

export default component(WindowResize);
